import { render, staticRenderFns } from "./EventAvatarCard.vue?vue&type=template&id=c3e2f3a0"
import script from "./EventAvatarCard.vue?vue&type=script&lang=ts"
export * from "./EventAvatarCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports